"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.program = exports.user = void 0;
const radio_dispatch_1 = require("@clearsummit/radio-dispatch");
const effects_1 = require("redux-saga/effects");
const services_1 = __importDefault(require("@/helpers/services"));
const payment_1 = require("@/redux/payment");
const program_1 = require("@/redux/program");
const therapy_1 = require("@/redux/therapy");
const user_1 = require("@/redux/user");
const payment = __importStar(require("./payment"));
const program = __importStar(require("./program"));
exports.program = program;
const therapy = __importStar(require("./therapy"));
const user = __importStar(require("./user"));
exports.user = user;
function* root() {
    yield effects_1.all(radio_dispatch_1.createNetworkSagas(services_1.default));
    yield effects_1.all([
        // USERS
        effects_1.takeLatest(user_1.ACTIONS.SET_USER_SESSION, user.authSuccess),
        effects_1.takeLatest(user_1.ACTIONS.CREATE_USER, user.setCreateUser),
        effects_1.takeLatest(user_1.ACTIONS.HYDRATE_USER_SUCCESS, user.setUserSession),
        effects_1.takeLatest(user_1.ACTIONS.HYDRATE_USER_FAILURE, user.logout),
        effects_1.takeLatest(user_1.ACTIONS.LOGOUT, user.logout),
        effects_1.takeLatest(user_1.ACTIONS.RESET_PASSWORD_SUCCESS, user.resetPasswordSuccess),
        effects_1.takeLatest(user_1.ACTIONS.RESET_PASSWORD_CHANGE_SUCCESS, user.resetPasswordChangeSuccess),
        effects_1.takeLatest(user_1.ACTIONS.CREATE_PASSWORD_SUCCESS, user.createPasswordSuccess),
        effects_1.takeLatest(user_1.ACTIONS.LIST_USERS_REQUEST, user.listUsersRequest),
        effects_1.takeLatest(user_1.ACTIONS.BULK_USERS_REQUEST, user.bulkUsersRequest),
        effects_1.takeLatest(user_1.ACTIONS.BULK_USERS_SUCCESS, user.bulkUsersSuccess),
        effects_1.takeLatest(user_1.ACTIONS.BULK_USERS_FAILURE, user.bulkUsersFailure),
        effects_1.takeLatest(user_1.ACTIONS.LIST_CAREGIVERS_REQUEST, user.listCaregiversRequest),
        effects_1.takeLatest(user_1.ACTIONS.CREATE_USER_SUCCESS, user.createUserSuccess),
        effects_1.takeLatest(user_1.ACTIONS.UPDATE_USER_SUCCESS, user.updateUserSuccess),
        effects_1.takeLatest(user_1.ACTIONS.DELETE_USER_SUCCESS, user.deleteUserSuccess),
        effects_1.takeLatest(user_1.ACTIONS.DELETE_USER_FAILURE, user.deleteUserFailure),
        effects_1.takeLatest(user_1.ACTIONS.UPDATE_PATIENT_PROGRESS_SECTION_REQUEST, user.updatePatientProgressSectionRequest),
        effects_1.takeLatest(user_1.ACTIONS.UPDATE_PATIENT_PROGRESS_SECTION_SUCCESS, user.updatePatientProgressSectionSuccess),
        effects_1.takeLatest(user_1.ACTIONS.UPDATE_PATIENT_PROGRESS_CONTENT_SUCCESS, user.updatePatientProgressContentSuccess),
        effects_1.takeLatest(user_1.ACTIONS.UPDATE_PATIENT_PROGRESS_CONTENT_REQUEST, user.updatePatientProgressContentRequest),
        effects_1.takeLatest(user_1.ACTIONS.UPDATE_PATIENT_PROGRESS_SECTION_FAILURE, user.updatePatientProgressSectionFailure),
        effects_1.takeLatest(user_1.ACTIONS.UPDATE_PATIENT_PROGRESS_CONTENT_FAILURE, user.updatePatientProgressContentFailure),
        // PROGRAMS
        effects_1.takeLatest(program_1.ACTIONS.SET_PROCESS_QUESTION_SUCCESS, program.processQuestionSuccess),
        effects_1.takeLatest(program_1.ACTIONS.LIST_PROGRAMS_REQUEST, program.listProgramsRequest),
        effects_1.takeLatest(program_1.ACTIONS.CREATE_PROGRAM_SUCCESS, program.createProgramSuccess),
        effects_1.takeLatest(program_1.ACTIONS.DELETE_ADMIN_PROGRAM_SUCCESS, program.deleteAdminProgramSuccess),
        effects_1.takeLatest(program_1.ACTIONS.DELETE_ADMIN_SECTION_SUCCESS, program.deleteAdminSectionSuccess),
        effects_1.takeLatest(program_1.ACTIONS.CREATE_SECTION_SUCCESS, program.saveSectionSuccess),
        effects_1.takeLatest(program_1.ACTIONS.CREATE_SECTION_FAILURE, program.saveSectionFailure),
        effects_1.takeLatest(program_1.ACTIONS.EDIT_SECTION_SUCCESS, program.saveSectionSuccess),
        effects_1.takeLatest(program_1.ACTIONS.EDIT_SECTION_FAILURE, program.saveSectionFailure),
        // PAYMENTS
        effects_1.takeLatest(payment_1.ACTIONS.CREATE_PAYMENT_SUCCESS, payment.createPaymentSuccess),
        effects_1.takeLatest(payment_1.ACTIONS.CREATE_PAYMENT_FAILURE, payment.createPaymentFailure),
        // THERAPY
        effects_1.takeLatest(therapy_1.ACTIONS.UPDATE_THERAPY_NOTE_SUCCESS, therapy.updateTherapyNoteSuccess),
        effects_1.takeLatest(therapy_1.ACTIONS.CREATE_THERAPY_NOTE_SUCCESS, therapy.createTherapyNoteSuccess),
        effects_1.takeLatest(therapy_1.ACTIONS.DELETE_THERAPY_NOTE_SUCCESS, therapy.deleteTherapyNoteSuccess),
    ]);
    yield user.startup();
}
exports.default = root;
